// extracted by mini-css-extract-plugin
module.exports = {"RoleMngSetting":"RoleMngSetting_RoleMngSetting__1Xma8"};